import { connect } from 'react-redux';
import IRCTCCaptchaPage from './IRCTCCaptchaPage';
import { getIRCTCBookingId } from '../../pages/thankYou/action/ThankyouActions';

const mapStateToProps = (state) => {
  const { thankYou: { irctcBookingId, verifiedUserId }, traveller: { bookingReviewResponse } } = state;
  return { irctcBookingId, bookingReviewResponse, verifiedUserId };
};

const mapDispatchToProps= (dispatch) => ({
  getIRCTCBookingId:
    (bookingId) => dispatch(getIRCTCBookingId(bookingId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IRCTCCaptchaPage);
